<template>
  <section id="hot-subject">
    <h3 :class="[{'bold':!iconShow}]">
      <span v-if="iconShow" class="iconfont">&#xe61c;</span>
      {{ $t('hot-subject.title') }}
    </h3>
    <ul v-if="hotThemeData && hotThemeData.length>0">
      <li v-for="(item,index) in hotThemeData" :key="index">
        <section class="user-info">
          <a class="avatar" :href="item.link" target="_blank">
            <img :src="item.coverImageUrl+'?x-oss-process=image/resize,m_fixed,w_240,h_240/quality,Q_60'" alt>
          </a>
          <section class="user-name">
            <div class="user-center">
              <a :href="item.link" target="_blank">
                <span class="user-nick">{{item.name}}</span>
              </a>
              <p class="user-pay">
                <span>
                  {{item.followCount >= 1000
                  ?(item.followCount/1000).toFixed(1)+'千':item.followCount}}
                </span> 人关注
              </p>
            </div>
            <div style="flex-grow: 1;"></div>
            <BtnFocus class="attention" 
            :subjectId="item.subjectId" 
            :isFollow="item.isFollow" 
            @success="refresh" />
          </section>
        </section>
        <a :href="item.articleLink" target="_blank" class="articleLink" v-if="item.updateTimestamp">
          <p>
            <span class="updateTime">{{item.updateTimestamp | siederBarformatTime}}更新:</span>
            {{item.articleTitle}}
          </p>
        </a>
      </li>
    </ul>
    <ul v-else>
      <li style="text-align:center;color:#999;font-size:14px">
        暂无热门主题
      </li>

    </ul>
  </section>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import * as types from "~/types";
import BtnFocus from "@/components/subject/btn-focus.vue";
import initTime from "~/plugins/initTime.js";
import * as api from "~/api/index";
export default {
  props: ["hotThemeData", "hotSubjectDatas"],
  components: {
    BtnFocus
  },
  data() {
    return {
      iconShow: null,
      HotThemeList: []
    };
  },
  created() {
    if (this.$route.path === "/") {
      this.iconShow = false;
    } else if (this.$route.path.indexOf("/subject") > -1) {
      this.iconShow = true;
    }
  },
  mounted() {
    // this.$emit("hotSubject");
    // this.activeHotTheme();
    // this.hotSubject();
  },
  methods: {
    ...mapMutations("user", [types.SHOW_LOGIN_FORM]),
    refresh() {
      this.$emit("refresh");
    },
    // activeHotTheme() {
    //   if (this.hotThemeData) {
    //     this.HotThemeList = this.hotThemeData.slice(0, 5);
    //     if (this.hotSubjectDatas && this.hotThemeData.length < 5) {
    //       let hotSubjectData = this.hotSubjectDatas.slice(
    //         0,
    //         5 - this.hotThemeData.length
    //       );
    //       this.HotThemeList = hotSubjectData.concat(this.hotThemeData);
    //     }
    //   } else {
    //     this.HotThemeList = this.hotSubjectDatas.slice(0, 5);
    //   }
    // },
    async hotSubject() {

    }
  },
  computed: {
    ...mapGetters("user", ["isLogin", "userId"])
  },
  watch: {
    isLogin() {
      this.$emit("hotSubject");
    }
  }
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

#hot-subject {
  width: 328px;
  background-color: #fff;

  h3 {
    padding: 20px 0 0 22px;
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    display: flex;
    align-items: center;

    span {
      font-weight: 100;
      vertical-align: top;
      display: inline-block;
      font-size: 22px;
      color: #318afb;
      margin-right: 4px;
    }
  }

  .bold {
    font-size: 16px !important;
    font-weight: bold;
  }

  ul {
    padding-bottom: 10px;
    margin: 0 20px;
    margin-top: 16px;
    border-top: 0.5px solid #e8e8e8;

    li {
      // height: 126px;
      border-bottom: 0.5px dashed #e8e8e8;
      padding: 20px 0;

      &:last-child {
        border-bottom: none;
        margin: 0;
      }

      .user-info {
        display: flex;
        align-items: center;

        a {
          display: block;
        }

        .avatar {
          height: 60px;
          width: 60px;
          position: relative;
          z-index: 5;
          overflow: hidden;
          border-radius: 2px;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .user-name {
          width: 208px;
          display: flex;
          align-items: center;
          align-content: center;
          margin-left: 17px;

          .user-center {
            width: 122px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-flow: column wrap;
            a {
              display: block;
              width: 100%;
              .user-nick {
                display: inline-block;
                font-weight: 600;
                line-height: 1.3;
                font-size: 16px;
                color: #222222;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;

                &:hover {
                  color: #3278d2;
                }
              }
            }

            .user-pay {
              width: 122px;
              font-size: 13px;
              color: #838d97;
              display: block;
              margin-top: 7px;

              span {
                color: #222222;
              }
            }
          }
        }
      }

      > a {
        display: inline-block;

        p {
          font-size: 14px;
          padding-top: 10px;
          color: #222222;
          line-height: 22px;
          text-overflow: ellipsis;
          height: 52px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          .updateTime {
            color: #3278d2;
          }
        }
      }
    }
  }

  .defaultText {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #999999;
  }
  .articleLink p:hover {
    color: #3278d2;
  }
}
</style>
